export const SET_FINPLAYER_DATA_INIT = 'SET_FINPLAYER_DATA_INIT';
export const SET_FINPLAYER_DATA_SUCCESS = 'SET_FINPLAYER_DATA_SUCCESS';
export const SET_FINPLAYER_DATA_ERROR = 'SET_FINPLAYER_DATA_ERROR';
export const CLEAR_FINPLAYER_DATA = 'CLEAR_FINPLAYER_DATA';
export const SET_SHOW_FINPLAYER = 'SET_SHOW_FINPLAYER';

